import React from 'react'
import { Dropdown } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ROUTES from '../../../constants/client-endpoints'

const ExperiencesEditMenu = ({
    experience = {},
}) => {
    const { isAdmin, isFacilitator } = useCurrentUser()
    const { toLocation } = useClientLocation()
    const url = CLIENT_ROUTES.EXPERIENCE.replace(':experienceId', experience.id)

    return (
        <Dropdown.Item
            onClick={() => toLocation(url)}
            disabled={!isAdmin && !isFacilitator}
        >
            Preview
        </Dropdown.Item>
    )
}

export default ExperiencesEditMenu